import { render, staticRenderFns } from "./FePartCategories.vue?vue&type=template&id=2a1b7e4e"
import script from "./FePartCategories.vue?vue&type=script&lang=js"
export * from "./FePartCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports